import { render, staticRenderFns } from "./CustomerHistoryItemDifferencesPopup.vue?vue&type=template&id=053c0793&"
import script from "./CustomerHistoryItemDifferencesPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerHistoryItemDifferencesPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports